/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivityTypePost } from '../models';
// @ts-ignore
import type { ActivityTypeReorder } from '../models';
// @ts-ignore
import type { ActivityTypeResponse } from '../models';
// @ts-ignore
import type { DeleteResponse } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { WorklistEntityType } from '../models';
/**
 * ActivityTypeApi - axios parameter creator
 * @export
 */
export const ActivityTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete an activity type for an entity type
         * @summary Delete an activity type for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} activityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityType: async (entityType: WorklistEntityType, activityTypeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('deleteActivityType', 'entityType', entityType)
            // verify required parameter 'activityTypeId' is not null or undefined
            assertParamExists('deleteActivityType', 'activityTypeId', activityTypeId)
            const localVarPath = `/api/v1/fhir/activityType/{entityType}/{activityTypeId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"activityTypeId"}}`, encodeURIComponent(String(activityTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all activity types for an entity type
         * @summary Get all activity types for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityTypes: async (entityType: WorklistEntityType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getActivityTypes', 'entityType', entityType)
            const localVarPath = `/api/v1/fhir/activityType/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch an activity type for an entity type
         * @summary Patch an activity type for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {ActivityTypePost} activityTypePost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityType: async (entityType: WorklistEntityType, activityTypePost: ActivityTypePost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('patchActivityType', 'entityType', entityType)
            // verify required parameter 'activityTypePost' is not null or undefined
            assertParamExists('patchActivityType', 'activityTypePost', activityTypePost)
            const localVarPath = `/api/v1/fhir/activityType/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityTypePost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch an activity type for an entity type
         * @summary Patch an activity type for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {Array<ActivityTypeReorder>} activityTypeReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderActivityType: async (entityType: WorklistEntityType, activityTypeReorder: Array<ActivityTypeReorder>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('reorderActivityType', 'entityType', entityType)
            // verify required parameter 'activityTypeReorder' is not null or undefined
            assertParamExists('reorderActivityType', 'activityTypeReorder', activityTypeReorder)
            const localVarPath = `/api/v1/fhir/activityType/{entityType}/reorder`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityTypeReorder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityTypeApi - functional programming interface
 * @export
 */
export const ActivityTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete an activity type for an entity type
         * @summary Delete an activity type for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} activityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivityType(entityType: WorklistEntityType, activityTypeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivityType(entityType, activityTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityTypeApi.deleteActivityType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all activity types for an entity type
         * @summary Get all activity types for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityTypes(entityType: WorklistEntityType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityTypes(entityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityTypeApi.getActivityTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch an activity type for an entity type
         * @summary Patch an activity type for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {ActivityTypePost} activityTypePost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchActivityType(entityType: WorklistEntityType, activityTypePost: ActivityTypePost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchActivityType(entityType, activityTypePost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityTypeApi.patchActivityType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch an activity type for an entity type
         * @summary Patch an activity type for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {Array<ActivityTypeReorder>} activityTypeReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderActivityType(entityType: WorklistEntityType, activityTypeReorder: Array<ActivityTypeReorder>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderActivityType(entityType, activityTypeReorder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityTypeApi.reorderActivityType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityTypeApi - factory interface
 * @export
 */
export const ActivityTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityTypeApiFp(configuration)
    return {
        /**
         * Delete an activity type for an entity type
         * @summary Delete an activity type for an entity type
         * @param {ActivityTypeApiDeleteActivityTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityType(requestParameters: ActivityTypeApiDeleteActivityTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponse> {
            return localVarFp.deleteActivityType(requestParameters.entityType, requestParameters.activityTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all activity types for an entity type
         * @summary Get all activity types for an entity type
         * @param {ActivityTypeApiGetActivityTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityTypes(requestParameters: ActivityTypeApiGetActivityTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityTypeResponse>> {
            return localVarFp.getActivityTypes(requestParameters.entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch an activity type for an entity type
         * @summary Patch an activity type for an entity type
         * @param {ActivityTypeApiPatchActivityTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchActivityType(requestParameters: ActivityTypeApiPatchActivityTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchActivityType(requestParameters.entityType, requestParameters.activityTypePost, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch an activity type for an entity type
         * @summary Patch an activity type for an entity type
         * @param {ActivityTypeApiReorderActivityTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderActivityType(requestParameters: ActivityTypeApiReorderActivityTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderActivityType(requestParameters.entityType, requestParameters.activityTypeReorder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityTypeApi - interface
 * @export
 * @interface ActivityTypeApi
 */
export interface ActivityTypeApiInterface {
    /**
     * Delete an activity type for an entity type
     * @summary Delete an activity type for an entity type
     * @param {ActivityTypeApiDeleteActivityTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApiInterface
     */
    deleteActivityType(requestParameters: ActivityTypeApiDeleteActivityTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponse>;

    /**
     * Get all activity types for an entity type
     * @summary Get all activity types for an entity type
     * @param {ActivityTypeApiGetActivityTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApiInterface
     */
    getActivityTypes(requestParameters: ActivityTypeApiGetActivityTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityTypeResponse>>;

    /**
     * Patch an activity type for an entity type
     * @summary Patch an activity type for an entity type
     * @param {ActivityTypeApiPatchActivityTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApiInterface
     */
    patchActivityType(requestParameters: ActivityTypeApiPatchActivityTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Patch an activity type for an entity type
     * @summary Patch an activity type for an entity type
     * @param {ActivityTypeApiReorderActivityTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApiInterface
     */
    reorderActivityType(requestParameters: ActivityTypeApiReorderActivityTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for deleteActivityType operation in ActivityTypeApi.
 * @export
 * @interface ActivityTypeApiDeleteActivityTypeRequest
 */
export interface ActivityTypeApiDeleteActivityTypeRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityTypeApiDeleteActivityType
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof ActivityTypeApiDeleteActivityType
     */
    readonly activityTypeId: string
}

/**
 * Request parameters for getActivityTypes operation in ActivityTypeApi.
 * @export
 * @interface ActivityTypeApiGetActivityTypesRequest
 */
export interface ActivityTypeApiGetActivityTypesRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityTypeApiGetActivityTypes
     */
    readonly entityType: WorklistEntityType
}

/**
 * Request parameters for patchActivityType operation in ActivityTypeApi.
 * @export
 * @interface ActivityTypeApiPatchActivityTypeRequest
 */
export interface ActivityTypeApiPatchActivityTypeRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityTypeApiPatchActivityType
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {ActivityTypePost}
     * @memberof ActivityTypeApiPatchActivityType
     */
    readonly activityTypePost: ActivityTypePost
}

/**
 * Request parameters for reorderActivityType operation in ActivityTypeApi.
 * @export
 * @interface ActivityTypeApiReorderActivityTypeRequest
 */
export interface ActivityTypeApiReorderActivityTypeRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityTypeApiReorderActivityType
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {Array<ActivityTypeReorder>}
     * @memberof ActivityTypeApiReorderActivityType
     */
    readonly activityTypeReorder: Array<ActivityTypeReorder>
}

/**
 * ActivityTypeApi - object-oriented interface
 * @export
 * @class ActivityTypeApi
 * @extends {BaseAPI}
 */
export class ActivityTypeApi extends BaseAPI implements ActivityTypeApiInterface {
    /**
     * Delete an activity type for an entity type
     * @summary Delete an activity type for an entity type
     * @param {ActivityTypeApiDeleteActivityTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApi
     */
    public deleteActivityType(requestParameters: ActivityTypeApiDeleteActivityTypeRequest, options?: RawAxiosRequestConfig) {
        return ActivityTypeApiFp(this.configuration).deleteActivityType(requestParameters.entityType, requestParameters.activityTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all activity types for an entity type
     * @summary Get all activity types for an entity type
     * @param {ActivityTypeApiGetActivityTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApi
     */
    public getActivityTypes(requestParameters: ActivityTypeApiGetActivityTypesRequest, options?: RawAxiosRequestConfig) {
        return ActivityTypeApiFp(this.configuration).getActivityTypes(requestParameters.entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch an activity type for an entity type
     * @summary Patch an activity type for an entity type
     * @param {ActivityTypeApiPatchActivityTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApi
     */
    public patchActivityType(requestParameters: ActivityTypeApiPatchActivityTypeRequest, options?: RawAxiosRequestConfig) {
        return ActivityTypeApiFp(this.configuration).patchActivityType(requestParameters.entityType, requestParameters.activityTypePost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch an activity type for an entity type
     * @summary Patch an activity type for an entity type
     * @param {ActivityTypeApiReorderActivityTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityTypeApi
     */
    public reorderActivityType(requestParameters: ActivityTypeApiReorderActivityTypeRequest, options?: RawAxiosRequestConfig) {
        return ActivityTypeApiFp(this.configuration).reorderActivityType(requestParameters.entityType, requestParameters.activityTypeReorder, options).then((request) => request(this.axios, this.basePath));
    }
}

